<div id="c-s-page">
<div id="c-s-content">
<div id="brand-center">
    <a id="mbbrand" class="header-link" style="pointer-events: none;">
      <video role="presentation" [preload]="true" [muted]="true" playsinline="" autoplay class="brandhub-header__video" #video>
        <source src="../../../assets/media/original.mp4" type="video/mp4">
      </video>
      <picture class="brandhub-header__logo">
        
        <img src="../../../assets/images/MB-star_white.svg" alt="Mercedes-Benz brand logo" class="brandhub-picture brandhub-picture--contain" style="width: 48px; height: auto;">
      </picture>

    </a>
  </div>
  <h1 id='msg'>Coming soon</h1>
  </div>
</div> 
